export default __webpack_public_path__ + "static/media/bg-2.31f40f00.png";